module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-43-72231ffb632e45e2ee883182ce9e07b5.svg";